module.exports = __webpack_public_path__ + "images/emoji/traffic_light.32a17229786ea265e3ae.png";